/**
 * Юрназвание оператора из реестра → привычный бренд: «ООО "Т2 МОБАЙЛ"» на
 * экране читается как документ, а не как подсказка. Неизвестное юрлицо
 * показывается как есть — это честнее пустоты.
 *
 * Таблица одна на всё приложение: карточка диспетчера и список очереди у
 * админа обязаны называть оператора одинаково.
 */
export function carrierBrand(raw: string): string {
  const upper = raw.toUpperCase();
  if (upper.includes('Т2') || upper.includes('T2')) return 'Tele2';
  if (upper.includes('МТС')) return 'МТС';
  if (upper.includes('МЕГАФОН')) return 'МегаФон';
  if (upper.includes('ВЫМПЕЛ')) return 'Билайн';
  if (upper.includes('ЙОТА') || upper.includes('YOTA') || upper.includes('СКАРТЕЛ')) return 'Yota';
  if (upper.includes('СБЕРТЕЛ') || upper.includes('СБЕРБАНК')) return 'СберМобайл';
  if (upper.includes('ТИНЬКОФФ') || upper.includes('Т-МОБАЙЛ')) return 'Т-Мобайл';
  return raw.replace(/^(ООО|ПАО|АО|ЗАО)\s*/i, '').replace(/^"|"$/g, '');
}
